// -----------------------------------------------------------------------------
// KI-Marktplatz
// -----------------------------------------------------------------------------

import swal from '../../../js/sweetalert.min.js'; // eslint-disable-line new-cap

window.Mustache = Mustache; // eslint-disable-line no-undef

const init = () => {
  if ($('.js-questionnaire-form-profile').length > 0) {
    saveQuestionnaire();
    sendQuestionnaire();
  }

  if ($('.js-body').hasClass('js-body-ki-marktplatz') === false) {
    return;
  }

  // Passwort-Anforderungen prüfen
  if ($('.js-body').find('.js-ki-faq').length) {
    showFaq();
  }

  if ($('.js-questionnaire-form-profile').length <= 0) {
    initEventListeners();
  }
};

/**
 * KI-Markplatz einrichten
 */
const initEventListeners = () => {
  // Scrolling Effect navbar fur ki
  $(window).on('scroll', function () {
    var offset = $('.ki__header').next().offset().top;
    var nav = $('#header').height();
    if ($(window).scrollTop() >= (offset - nav)) {
      $('header .aws-navbar, header #header').attr('style', 'background-color: #00377a !important');
      $('header .btn-login').fadeIn();
    } else {
      $('header .aws-navbar, header #header').attr('style', 'background-color: transparent !important');
      $('header .btn-login').fadeOut();
    }
  });

  saveQuestionnaire();

  if ($('.js-ki-article').length ) {
    loadArticles();
  }

  showContent();
  sendQuestionnaire();
};

/**
 * Artikel laden
 */
const loadArticles = () => {
  const basepath = $('.js-body').attr('data-basepath');

  $.ajax({
    method: 'GET',
    url: `${basepath}/api/getArticles/32`,
    contentType: 'application/json'
  })
    .done(function (data) {
      const dataParsed = JSON.parse(data);
      const $templateArticles = $('#templateArticles');
      const html = Mustache.to_html($templateArticles.html(), dataParsed); // eslint-disable-line no-undef
      $templateArticles.after(html);
    })
  ;
};


/**
 * Fragebogen speichern
 */
const saveQuestionnaire = () => {
  const basepath = $('.js-body').attr('data-basepath');
  $(document).on('click', '.js-saveData', function (e) {
    e.preventDefault();
    var action = $(this).data('action');
    var text = 'Ihre Daten wurden aktualisiert. \n\n Sie wurden für das Program KI angemeldet.';
    if (action === 'update') {
      text = 'Ihre Daten wurden aktualisiert.';
    }
    $.ajax({
      url: `${basepath}/ki-marktplatz/save`,
      type: 'POST',
      data: $('form').serialize(),
      success: function (response) {
        if (response.route) {
          window.location.href = response.route;
        } else {
          swal({ // eslint-disable-line new-cap
            title: 'Gespeichert!',
            text: text,
            buttons: {
              confirm: {text: 'OK'}
            },
            dangerMode: false,
            reverseButtons: true
          });
        }
      }
    });
  });
};

/**
 * Fragebogen abschicken
 */
const sendQuestionnaire = () => {
  const basepath = $('.js-body').attr('data-basepath');

  $('.js-questionnaire-form').on('submit', function (e) {
    e.preventDefault();
    var referrer = ($(this).data('link'));
    $.ajax({
      type: 'post',
      url: `${basepath}/ki-marktplatz/questionnaire`,
      data: $('form').serialize(),
      success: function (data) {
        if (referrer !== 'undefined' && referrer === 'profile') {
          var htmlContent = document.createElement('div');
          htmlContent.innerHTML = data.html;
          swal({ // eslint-disable-line new-cap
            content: htmlContent,
            buttons: {
              confirm: {text: 'OK'}
            },
            className: 'questionnaire-swal'
          });
        } else {
          var container = $('.js-questionnaire');
          container.after(data.html);
          container.hide();
          var target = $('.js-questionnaire-answer');
          if (target.length) {
            $('html,body').animate({
              scrollTop: target.offset().top - 95
            }, 1000);
          }
        }
      }
    });
  });
};

/**
 * Inhalte anzeigen
 */
const showContent = () => {
  $('.js-anchor').click(function () {
    var target = $(this).data('target');
    $('.js-dynamic-content-ki').not(target).slideUp();
    $(target).slideDown();
  });
};

/**
 * FAQs durch Wert im URL anzegen
 */
const showFaq = () => {
  var preFaq = location.hash;
  if (preFaq !== '') {
    $(preFaq).addClass('show');
  }
};

export {
  init
};
